export default function AdminUsers() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">User Management</h1>
      <div className="card p-6">
        <p className="text-gray-500">User management coming soon...</p>
      </div>
    </div>
  );
}
